import React, {useCallback, useState} from 'react';

import Button from '@pb/kit-component-button';
import {Dialog} from '@pb/kit-component-dialog-v2';

import {AddContractModal} from './add-contract-modal';

type Props = {
    accountId: number,
    canEdit: boolean,
    saving: boolean,
    onContractCreated: () => void,
};

export const AddContractDialog = ({accountId, canEdit, saving, onContractCreated}: Props) => {
    const [shown, setShown] = useState(false);

    const onModalOpen = useCallback(() => {
        setShown(true);
    }, []);

    const onModalClose = useCallback(() => {
        if (!saving) {
            setShown(false);
        }
    }, [saving]);

    const onCreated = useCallback(() => {
        setShown(false);
        onContractCreated();
    }, [onContractCreated]);

    return (
        <>
            <Dialog
                shown={shown}
                setShown={value => {
                    if (!value) {
                        onModalClose();
                    }
                }}>
                <AddContractModal
                    accountId={accountId}
                    onClose={onModalClose}
                    onCreated={onCreated}
                />
            </Dialog>
            <Button variant="Type.PRIMARY" onClick={onModalOpen} disabled={!canEdit}>
                Add New Contract
            </Button>
        </>
    );
};
